<p-floatlabel [class]="'w-full flex-1 block ' + (wrapperClass || '')" [formGroup]="formGroup">
  <p-select class="w-full" styleClass="w-full"
    appendTo="body"
    [inputId]="id"
    [formControlName]="id"
    [placeholder]="placeholder"
    optionLabel="description" [options]="options" optionValue="code"
    (onChange)="onChangeValue($event)">
  </p-select>
  <label [for]="id">{{label}}</label>
</p-floatlabel>
@if (formError) {
  <app-form-error [message]="formError"></app-form-error>
}
